import React , {useState} from 'react'
import BladderPainList from './BladderPainList'

export default function BladderPainMain({data}) {
      const [activeTab, setActiveTab] = useState("fluid-intake");
  return (
   <>
   <div className="graph-btns tabs">
            <button className={activeTab === 'fluid-intake' ? 'active' : ''} onClick={() => setActiveTab("fluid-intake")}>Fluid Intake</button> 
            <button className={activeTab === 'voids' ? 'active' : ''} onClick={() => setActiveTab("voids")}>Voids</button>     
    </div>

     <div className="chart-blk mt-2">
        
            {activeTab === "fluid-intake" && <BladderPainList data={data} type="Drink" />}
            {activeTab === "voids" && <BladderPainList data={data} type="Urination" />}

          </div>
   </>
  )
}
